"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require("redux-saga/effects");

var _authTokenActions = require("../actions/authTokenActions");

var _requirementDataActions = require("../actions/requirementDataActions");

var _bookingMetaDataActions = require("../actions/bookingMetaDataActions");

var _primaryCustomerDataActions = require("../actions/primaryCustomerDataActions");

var _bookingDataActions = require("../actions/bookingDataActions");

var _checkinDataActions = require("../actions/checkinDataActions");

var _transferServicesDataActions = require("../actions/transferServicesDataActions");

var _bookingServicesActions = require("../actions/bookingServicesActions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(triggerBookingSubresourceRequests);

/**
 * After authentication, we need to load the booking's sub-resources:
 *
 * - requirements:
 *     Used to fill the forms with data.
 *
 * - booking meta:
 *     Used to determine direct vs. agent travellers and primary customer.
 *
 * - primary customer:
 *     Used to determine primary country code.
 *
 * - checkins:
 *     Used to generate the reminder URLs.
 */
function triggerBookingSubresourceRequests() {
  return _regenerator2.default.wrap(function triggerBookingSubresourceRequests$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 23;
            break;
          }

          _context.next = 3;
          return (0, _effects.take)([_authTokenActions.AUTH_TOKEN_PROVIDED, _authTokenActions.AUTH_TOKEN_RECEIVED]);

        case 3:
          _context.next = 5;
          return (0, _effects.put)((0, _requirementDataActions.requirementDataRequested)());

        case 5:
          _context.next = 7;
          return (0, _effects.put)((0, _bookingMetaDataActions.bookingMetaDataRequested)());

        case 7:
          _context.next = 9;
          return (0, _effects.take)(_bookingMetaDataActions.BOOKING_META_DATA_RECEIVED);

        case 9:
          _context.next = 11;
          return (0, _effects.put)((0, _primaryCustomerDataActions.primaryCustomerDataRequested)());

        case 11:
          _context.next = 13;
          return (0, _effects.put)((0, _bookingDataActions.bookingDataRequested)());

        case 13:
          _context.next = 15;
          return (0, _effects.take)(_bookingDataActions.BOOKING_DATA_RECEIVED);

        case 15:
          _context.next = 17;
          return (0, _effects.put)((0, _checkinDataActions.checkinDataRequested)());

        case 17:
          _context.next = 19;
          return (0, _effects.take)(_bookingServicesActions.BOOKING_SERVICES_DATA_RECEIVED);

        case 19:
          _context.next = 21;
          return (0, _effects.put)((0, _transferServicesDataActions.transferServicesDataRequested)());

        case 21:
          _context.next = 0;
          break;

        case 23:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}

exports.default = triggerBookingSubresourceRequests;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/triggerBookingSubresourceRequests.js
// module id = 1422
// module chunks = 0